document.documentElement.classList.remove('no-js');

const menuButton = document.querySelector('[data-menu-toggle]');
const mobileMenu = document.querySelector('[data-mobile-menu]');
menuButton?.addEventListener('click', () => {
  const open = mobileMenu.classList.toggle('is-open');
  menuButton.setAttribute('aria-expanded', String(open));
});

const revealObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add('is-visible');
      revealObserver.unobserve(entry.target);
    }
  });
}, { rootMargin: '0px 0px -35px' });
document.querySelectorAll('.reveal').forEach((element) => revealObserver.observe(element));

document.querySelectorAll('[data-quick-add]').forEach((form) => {
  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const button = form.querySelector('button');
    button.disabled = true;
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(form.elements.id.value), quantity: 1 }] })
      });
      if (!response.ok) throw new Error('cart');
      const cart = await fetch(window.Shopify.routes.root + 'cart.js').then((result) => result.json());
      document.querySelectorAll('[data-cart-count]').forEach((element) => element.textContent = cart.item_count);
      showToast('تمت إضافة المنتج إلى السلة');
    } catch (error) {
      showToast('تعذر الإضافة. حاول مرة أخرى.');
    } finally {
      button.disabled = false;
    }
  });
});

function showToast(message) {
  const toast = document.querySelector('[data-cart-toast]');
  if (!toast) return;
  toast.textContent = message;
  toast.classList.add('is-visible');
  window.setTimeout(() => toast.classList.remove('is-visible'), 2600);
}

document.querySelector('[data-sort-by]')?.addEventListener('change', (event) => {
  const url = new URL(window.location.href);
  url.searchParams.set('sort_by', event.target.value);
  window.location.href = url.toString();
});

document.querySelectorAll('[data-qty-minus]').forEach((button) => button.addEventListener('click', () => {
  const input = button.parentElement.querySelector('input');
  input.value = Math.max(1, Number(input.value) - 1);
}));
document.querySelectorAll('[data-qty-plus]').forEach((button) => button.addEventListener('click', () => {
  const input = button.parentElement.querySelector('input');
  input.value = Number(input.value) + 1;
}));

document.querySelectorAll('[data-filter-toggle]').forEach((button) => button.addEventListener('click', () => {
  document.querySelector('[data-filter-panel]')?.classList.toggle('is-open');
}));


/* Green Guide: Arabic phone entry without cursor or deletion interference */
function ggNormalizeArabicDigits(value) {
  return String(value || '')
    .replace(/[٠-٩]/g, (digit) => String(digit.charCodeAt(0) - 1632))
    .replace(/[۰-۹]/g, (digit) => String(digit.charCodeAt(0) - 1776));
}

const ggPhoneInput = document.querySelector('[data-phone-input]');
if (ggPhoneInput) {
  ggPhoneInput.addEventListener('input', () => ggPhoneInput.setCustomValidity(''));
  ggPhoneInput.addEventListener('blur', () => {
    ggPhoneInput.value = ggNormalizeArabicDigits(ggPhoneInput.value);
  });
}

document.querySelector('#CartForm')?.addEventListener('submit', (event) => {
  if (event.submitter?.name !== 'checkout' || !ggPhoneInput) return;
  ggPhoneInput.value = ggNormalizeArabicDigits(ggPhoneInput.value);
  const phoneDigits = ggPhoneInput.value.replace(/\D/g, '');
  if (phoneDigits.length < 8 || phoneDigits.length > 15) {
    event.preventDefault();
    ggPhoneInput.setCustomValidity('أدخل رقم هاتف صحيحاً من 8 إلى 15 رقماً.');
    ggPhoneInput.reportValidity();
  }
});
